import * as React from "react";

import { isExpoRegistration } from "@/utilities/expoRegistration";

import { DIAGNOSIS_STEP_CHIP_LABELS } from "./diagnosisFlowStepDefinitions";
import { DiagnosisStepChip, DiagnosisStepChipsRow } from "./DiagnosisStepChip";

// プランナー紹介画面群（/diagnosis_compatibility_agents/*）共通のステップ表示。
export const DiagnosisCompatibilityAgentsStepChips: React.FC = () => {
  // エキスポ導線（Trello #241）では投資スタイル診断を飛ばしてここへ来るため、受けていない診断を「完了✓」として出さない。
  // 入口の種別は表示中に変わらないので、マウント時に1回だけ目印を読む（レンダーごとに localStorage を読まない）
  const [isExpo] = React.useState(() => isExpoRegistration());

  return (
    <DiagnosisStepChipsRow>
      <DiagnosisStepChip label={DIAGNOSIS_STEP_CHIP_LABELS.investment} state="completed" withCheck={true} v2 />
      {!isExpo && <DiagnosisStepChip label={DIAGNOSIS_STEP_CHIP_LABELS.style} state="completed" withCheck={true} v2 />}
      <DiagnosisStepChip animate label={DIAGNOSIS_STEP_CHIP_LABELS.planner} state="active" withCheck={false} v2 />
    </DiagnosisStepChipsRow>
  );
};
